import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation16 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7', '31']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (

        <>
       



        <div className="container mt-1 p-3 mb-1" >

            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}>
                        Certificate Course in C & C++ Programming

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>

                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >

                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in C & C++ Programming
                </h5>
                <p>
                    C is a widely used and user-friendly programming language known for its speed and simplicity, offering low-level memory access and a clean coding style. Learning C provides numerous advantages, enabling coding for diverse platforms and facilitating an easier transition to C++. Meanwhile, C++ is a versatile, object-oriented language blending high and low-level features, ideal for a range of applications from desktop software to performance-critical systems like telephone switches and video games.</p>

                <hr />
            </div>
            <h5 style={{ position: "relative" }}>

                Introduction
            </h5>
            <p>Do you enjoy coding? Do you want to build your career in Programming?</p>
            <p>Start learning C & C++ Programming with us!</p>
            <p>These programming languages is a widely used and developed to write an operating system. Also, to do application level programming. This is the building block of Computer Technology.</p>
            <p>C & C++ is one of the most widely used and user friendly programming language. It is faster than any others programming language. The main features of C & C++ language are simple set of keywords, low-level access to memory and clean style.</p>
            <hr />


            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>This course covers the fundamentals of Computer theories including the flow of a program using branch statements, repetition, nesting of structures, creating and modifying arrays, how arrays are organized in memory.</p>
            <p>This course covers the fundamentals of Computer theories including the flow of a program using branch statements, repetition, nesting of structures, creating and modifying arrays, how arrays are organized in memory.</p>
            <p>After completing this course, you can work as a Programmer, Embedded Programmer, System Engineer, System S/W Engineer, Network Security Engineer and Game Programmer.</p>



            <hr />

            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> C & C++ Programming course is jointly certified by CDOE, GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
           
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Brief Introduction</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Programming Language</li>
                                <li>About C Programming</li>
                                <li>C Character Set</li>
                                <li>Constants, Variables & Keywords</li>
                                <li>Constants in C</li>
                                <li>Variables in C</li>
                                <li>Writing a C Program</li>
                                <li>Instructions and Assignments</li>
                                <li>Basic Operators in C Programming</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">The Decision Control Structure</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Decisions Control Structure & the If Statement</li>
                                <li>The if-else Statement</li>
                                <li>Use of Logical Operators</li>
                                <li>Different types of Operators</li>
                                <li>Points to remember</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Loop Control Structure</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>  Loops and the While loop</li>
                                <li> While Loop</li>
                                <li> For Loop</li>
                                <li> Operators in Loop</li>
                                <li> The Odd Loop</li>
                                <li> Break Statement</li>
                                <li> Continue Statement</li>
                                <li> Do-while loop</li>
                                <li>  Tips to remember</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Case Control Structure</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li> Decisions using switch</li>
                                <li> The Tips and Traps</li>
                                <li>Switch versus if-else Ladder</li>
                                <li>The goto keyword</li>
                            </ul>
                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Functions and Pointers</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>About Functions</li>
                                <li>Passing Values between Functions</li>
                                <li>Scope Rule of Functions</li>
                                <li>Calling Convention</li>
                                <li>One Dicey Issue</li>
                                <li>Advanced Features of Functions</li>
                                <li>Function Declaration and Prototypes</li>
                                <li>Call by Value or Call by Reference</li>
                                <li>An Introduction to Pointers</li>
                                <li>Pointer Notation</li>
                                <li>Function Calls</li>
                                <li>Basics of Call by value and call by reference</li>
                                <li>Conclusions</li>
                                <li>Recursion</li>
                                <li>Recursion and Stack</li>
                                <li>Adding Functions to the Library</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Data Types Revisited</AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li>Data type</li>
                                <li>Integer number variables</li>
                                <li>Integers, signed and unsigned</li>
                                <li>Chars, signed and unsigned</li>
                                <li>Floats and Doubles</li>
                                <li>Issues related to Data types</li>
                                <li> Storage Classes in C</li>
                                <li>Automatic Storage Class</li>
                                <li>Register Storage Class</li>
                                <li>Static Storage Class</li>
                                <li>External Storage Class</li>
                                <li>To study the Ground rules for the Storage Class</li>
                            </ul>

                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">The C preprocessor </AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li>Features of C Preprocessor</li>
                                <li>Preprocessor and Macro Directives</li>
                                <li>Macros with Arguments and Macros versus Functions</li>
                                <li>Various Directives</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Arrays</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>What are Arrays?</li>
                                <li>Usage of Arrays</li>
                                <li>Pointers and Arrays</li>
                                <li>Passing an Entire Array to a Function</li>
                                <li>Two Dimensional Arrays</li>
                                <li>Initializing a 2-Dimensional Array</li>
                                <li>Memory Map of a 2-Dimensional Array</li>
                                <li>Pointers and 2-Dimensional Arrays</li>
                                <li>Pointer to an Array 295</li>
                                <li>Passing 2-D array to a Function</li>
                                <li>Array of Pointers</li>
                                <li>Three Dimensional Array</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Pupating on Strings</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>What are Strings?</li>
                                <li>Pointers and Strings</li>
                                <li>Standard Library String Functions</li>
                                <li>Two-Dimensional Array of Characters</li>
                                <li>Array of Pointers to Strings</li>
                                <li>Limitations of Array of Pointers to Strings</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">Structures</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li>Why Use Structures?</li>
                                <li>Declaring a Structure</li>
                                <li>Accessing Structure Elements</li>
                                <li>Array of Structures</li>
                                <li>Additional Features of Structures</li>
                                <li>Uses of Structures</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="17">Console Input/Output</AccordionHeader>
                        <AccordionBody accordionId="17">
                            <ul>
                                <li> Types of I/O</li>
                                <li> Formatted Console I/O Functions</li>
                                <li> sprintf( ) and sscanf( ) Functions</li>
                                <li>Unformatted Console I/O Functions</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="18">File Input/Output</AccordionHeader>
                        <AccordionBody accordionId="18">
                            <ul>
                                <li>Data Organization</li>
                                <li>File Operations</li>
                                <li>Opening a File</li>
                                <li>Reading from a File</li>
                                <li>Trouble in Opening a File</li>
                                <li>Closing the File</li>
                                <li>Counting Characters, Tabs, Spaces</li>
                                <li>A File-copy Program</li>
                                <li>Writing to a File</li>
                                <li>File Opening Modes</li>
                                <li>String (line) I/O in Files</li>
                                <li>The Awkward Newline</li>
                                <li>Record I/O inFiles</li>
                                <li>Text Files and Binary Files</li>
                                <li>Record I/O Revisited</li>
                                <li>Database Management</li>
                                <li>Low Level Disk I/O</li>
                                <li>A Low Level File-copy Program</li>
                                <li>I/O Under Windows</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="19">More Issues in Input/Output</AccordionHeader>
                        <AccordionBody accordionId="19">
                            <ul>
                                <li>Using argc and argv</li>
                                <li>Detecting Errors in Reading/Writing</li>
                                <li>Explanation</li>
                                <li>Standard I/O Devices</li>
                                <li>I/O Redirection</li>
                                <li>Redirecting the Output</li>
                                <li>Redirecting the Input & Both Ways at Once</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="20">Operations on Bits</AccordionHeader>
                        <AccordionBody accordionId="20">
                            <ul>
                                <li>Binay System & Bitwise Operators</li>
                                <li>Bitwise AND Operator</li>
                                <li>Bitwise OR Operator</li>
                                <li>Bitwise XOR Operator</li>
                                <li>One's Complement Operator</li>
                                <li>Shift Operator</li>
                                <li>The showbits( ) Function</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="21">Miscellaneous Features</AccordionHeader>
                        <AccordionBody accordionId="21">
                            <ul>
                                <li> Enumerated Data Type and its uses</li>
                                <li> Understanding with a Program</li>
                                <li> Renaming Data Types with typedef</li>
                                <li> Typecasting</li>
                                <li> Bit Fields</li>
                                <li> Pointers to Functions</li>
                                <li> Functions Returning Pointers</li>
                                <li> Functions with Variable Number of Arguments</li>
                                <li> Unions & Union of Structure</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="22">Under Windows 535</AccordionHeader>
                        <AccordionBody accordionId="22">
                            <ul>
                                <li>Uses of Windows</li>
                                <li>Integers</li>
                                <li>The Use of typedef</li>
                                <li>Pointers in the 32-bit World</li>
                                <li>Memory Management & Device Access</li>
                                <li>DOS Programming Model</li>
                                <li>Windows Programming Model</li>
                                <li>Event Driven Model & Windows programming</li>
                                <li>The First Windows Program</li>
                                <li>Hungarian Notation</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="23">Windows Programming</AccordionHeader>
                        <AccordionBody accordionId="23">
                            <ul>
                                <li>The Role of a Message Box</li>
                                <li>Here Comes the windows</li>
                                <li>More Windows</li>
                                <li>A Real-World Window</li>
                                <li>Creation and Displaying of Window</li>
                                <li>Interaction with Window</li>
                                <li>Reacting to Messages</li>
                                <li>Program Instances</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="24">Graphics under Windows</AccordionHeader>
                        <AccordionBody accordionId="24">
                            <ul>
                                <li>Graphics fundamentals</li>
                                <li>Device Independent Drawing</li>
                                <li>Hello Windows program</li>
                                <li>Drawing Shapes</li>
                                <li>Types of Pens</li>
                                <li>Types of Brushes</li>
                                <li>Code and Resources</li>
                                <li>Freehand Drawing, the Paintbrush Style</li>
                                <li>Capturing the Mouse</li>
                                <li>Device Context, a Closer Look</li>
                                <li>Displaying a Bitmap</li>
                                <li>Animation at Work</li>
                                <li>WM_CREATE and On Create( )</li>
                                <li>WM_TIMER and On Timer( )</li>
                                <li>Points to remember</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="25">Interaction with Hardware</AccordionHeader>
                        <AccordionBody accordionId="25">
                            <ul>
                                <li> Hardware Interaction</li>
                                <li>Hardware Interaction, DOS Perspective</li>
                                <li>Hardware Interaction, Windows Perspective</li>
                                <li>Communication with Storage Devices</li>
                                <li>The Read Sector( ) Function</li>
                                <li>Accessing Other Storage Devices</li>
                                <li>Communication with Keyboard</li>
                                <li>Dynamic Linking</li>
                                <li>Windows Hooks</li>
                                <li>Caps Locked, Permanently</li>
                                <li>Mangling Keys</li>
                                <li>Key Logger</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="26">Under Windows 535</AccordionHeader>
                        <AccordionBody accordionId="26">
                            <ul>
                                <li>Uses of Windows</li>
                                <li>Integers</li>
                                <li>The Use of typedef</li>
                                <li>Pointers in the 32-bit World</li>
                                <li>Memory Management & Device Access</li>
                                <li>DOS Programming Model</li>
                                <li>Windows Programming Model</li>
                                <li>Event Driven Model & Windows programming</li>
                                <li>The First Windows Program</li>
                                <li>Hungarian Notation</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="27">Under Linux</AccordionHeader>
                        <AccordionBody accordionId="27">
                            <ul>
                                <li> What is Linux</li>
                                <li> C Programming Under Linux</li>
                                <li> The ‘Hello Linux’ Program</li>
                                <li> Processes</li>
                                <li> Parent and Child Processes</li>
                                <li> More Processes</li>
                                <li> Zombies and Orphans</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="28">More Linux Programming</AccordionHeader>
                        <AccordionBody accordionId="28">
                            <ul>
                                <li>Communication using Signals</li>
                                <li>Handling Multiple Signals</li>
                                <li>Registering a Common Handler</li>
                                <li>Blocking Signals</li>
                                <li>Event Driven Programming</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="29">Memory Mapping</AccordionHeader>
                        <AccordionBody accordionId="29">
                            <ul>
                                <li>Introduction to Memory Map</li>
                                <li>Memory Organization</li>
                                <li>Segmentation</li>
                                <li>Loading OS & Booting Process</li>
                                <li>The resident and transient memory area</li>
                                <li>Program memory area at run time</li>
                                <li>Memory representation of data & function objects</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="30">C Traps & Pitfall</AccordionHeader>
                        <AccordionBody accordionId="30">
                            <ul>
                                <li>Introduction</li>
                                <li>Lexical pitfalls</li>
                                <li>Exceptions, String & characters</li>
                                <li>Understanding Declaration</li>
                                <li>Exceptions in Operators' precedence</li>
                                <li>Use of Semicolons</li>
                                <li>The Switch statement</li>
                                <li>Calling functions</li>
                                <li>The Dangling else problem</li>
                                <li>Linkages</li>
                                <li>External Types</li>
                                <li>Expression evaluation sequence</li>
                                <li>Issues related to actual parameters</li>
                                <li>Eshew Synecdoche</li>
                                <li>Library Function</li>
                                <li>Preprocessor</li>
                                <li>Portability pitfalls</li>
                                <li>Signed & Unsigned characters</li>
                                <li>Random numbers</li>
                                <li>Portability problems</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <hr></hr>
                <h5>C++ Programming:</h5>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="31">Intro to OOP</AccordionHeader>
                        <AccordionBody accordionId="31">
                            <ul>
                                <li>The Beginning</li>
                                <li>Structured Programming</li>
                                <li>Object Oriented Programing</li>
                                <li>Characteristics of Object Oriented Programing</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="32">Grad Function Prototypes</AccordionHeader>
                        <AccordionBody accordionId="32">
                            <ul>
                                <li> Comments</li>
                                <li> Flexible Declarations</li>
                                <li>Structure, union and enum Syntax</li>
                                <li> Anonymous unions and enums</li>
                                <li>Typecasting</li>
                                <li>Void Pointers</li>
                                <li>The Operator</li>
                                <li>References</li>
                                <li>The Const Qualifier</li>
                                <li>Constructors for Intrinsic Data Types</li>
                                <li>The bool Data Typecasting to C++</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="33">Functions</AccordionHeader>
                        <AccordionBody accordionId="33">
                            <ul>
                                <li>Function Prototypes</li>
                                <li>Function Overloading</li>
                                <li>Default Arguments in Functions</li>
                                <li>Operator Overloading</li>
                                <li>Inline Functions</li>
                                <li>Static, virtual and friend Function</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="34">Classes in C++</AccordionHeader>
                        <AccordionBody accordionId="34">
                            <ul>
                                <li>Classes and Constructors</li>
                                <li>Destructors</li>
                                <li>A Complex Class</li>
                                <li>Overloaded Operators Revisited</li>
                                <li>The Pointer</li>
                                <li>Overloading Unary Operators</li>
                                <li> Function Definition Outside The Class</li>
                                <li>Function Definition outside The Class</li>
                                <li>New and delete operators</li>
                                <li>Using new and delete</li>
                                <li> Malloc ( )/free( ) versus new/ delete</li>
                                <li>The Matrix Class</li>
                                <li> Classes, Objects and Memory</li>
                                <li>Structures and Classes</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="35">The C++ Free Store</AccordionHeader>
                        <AccordionBody accordionId="35">
                            <ul>
                                <li>Free Store Exhaustion</li>
                                <li>Custom new and delete operators</li>
                                <li>Overloading new/delete in Classes</li>
                                <li> Understanding the sequence</li>
                                <li>Construction at Predetermined Location</li>
                                <li>One Last Issue</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="36">Miscellaneous Class Issue</AccordionHeader>
                        <AccordionBody accordionId="36">
                            <ul>
                                <li>Static Class Data</li>
                                <li>Static Member Functions</li>
                                <li>Const and Classes</li>
                                <li>Overloaded Assignment Operator, Copy Constructor</li>
                                <li>Data Conversion</li>
                                <li>Data Conversion between Object of Different Classes</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="37">Data Structures through C++</AccordionHeader>
                        <AccordionBody accordionId="37">
                            <ul>
                                <li> Stacks and Queues</li>
                                <li> The Linked List</li>
                                <li> Stacks and Queues Revisited</li>
                                <li> Trees</li>
                                <li> Binary Trees</li>
                                <li> Traversal of a Binary Tree</li>
                                <li> Deletion from a Binary Tree</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="38">Inheritance</AccordionHeader>
                        <AccordionBody accordionId="38">
                            <ul>
                                <li> More Inheritance</li>
                                <li> Some More Inheritance</li>
                                <li> Multiple Levels of Inheritance</li>
                                <li> Multiple Inheritance</li>
                                <li> Constructors in Multiple Inheritance</li>
                                <li> A Word of Caution</li>
                                <li> Private Inheritance</li>
                                <li> Protected Inheritance</li>
                                <li> Uninherited Functions</li>
                                <li> Incremental Development</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="39">Virtual Functions</AccordionHeader>
                        <AccordionBody accordionId="39">
                            <ul>
                                <li> Pure Virtual Functions</li>
                                <li> Virtual Functions under the Hood</li>
                                <li> Why virtual Functions?</li>
                                <li> Virtual Functions in Derived Classes</li>
                                <li> Object Slicing</li>
                                <li> Virtual Functions and Constructors</li>
                                <li> Destructors and virtual Destructors</li>
                                <li> Virtual Base Classes</li>
                                <li> Putting it All Together</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="40">Input/Output in C++</AccordionHeader>
                        <AccordionBody accordionId="40">
                            <ul>
                                <li>The iostream Library</li>
                                <li> The ios Class</li>
                                <li>Manipulators</li>
                                <li>Creating Our Own Manipulators</li>
                                <li> User-defined Manipulators with Arguments</li>
                                <li> Come GUI and…</li>
                                <li> The istream Class</li>
                                <li> The ostream Class</li>
                                <li> The iostream Class</li>
                                <li> The with assign Classes</li>
                                <li> Predefined Stream Objects</li>
                                <li> Outputting Strings</li>
                                <li> A Brief Review</li>
                                <li> File I/O with Streams</li>
                                <li> A Better way</li>
                                <li> A File copy Program</li>
                                <li> File Opening Modes</li>
                                <li> Binary I/O</li>
                                <li> Elementary Database Management</li>
                                <li> Class That Read/Write Themselves</li>
                                <li> Errors during I/O</li>
                                <li> File copy Program Revisited</li>
                                <li> Overloading   </li>
                                <li> Str streams</li>
                                <li> Automatic Storage Allocation</li>
                                <li> Sending Output to Printer</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="41">Advanced Features</AccordionHeader>
                        <AccordionBody accordionId="41">
                            <ul>
                                <li>Classes Within Classes</li>
                                <li> Friend Functions</li>
                                <li>Overloading AND</li>
                                <li>One More Use Of friend Function</li>
                                <li>Friend Classes</li>
                                <li>A Word of Caution</li>
                                <li>Smart Pointers</li>
                                <li>More Smart Pointers</li>
                                <li>Pointers to Members</li>
                                <li>The explicit Keyword</li>
                                <li>The mutable Keyword</li>
                                <li>Namespaces</li>
                                <li>Using A Namespace</li>
                                <li>RTTI</li>
                                <li>When to Use RTTI</li>
                                <li>Typecasting in C++</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="42">Templates</AccordionHeader>
                        <AccordionBody accordionId="42">
                            <ul>
                                <li>Function Templates</li>
                                <li>A Template Based Quick Sort</li>
                                <li>Class Templates</li>
                                <li>A Linked List Class Template</li>
                                <li>Tips about List Class Template</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="43">Exception Handling</AccordionHeader>
                        <AccordionBody accordionId="43">
                            <ul>
                                <li>Checking Function Return Value</li>
                                <li>setjmp( ) and longjmp( )</li>
                                <li>Exception Handling in C++</li>
                                <li>Exception with Arguments</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="44">Case Studies</AccordionHeader>
                        <AccordionBody accordionId="44">
                            <ul>
                                <li>Tic Tac Toe Game</li>
                                <li>Student Management System</li>
                                <li>Student Attendance Management System</li>
                                <li>Event Management System</li>
                                <li>Hangman Game</li>
                                <li>Employee Leave Management System</li>
                                <li>Furniture Business System</li>
                                <li>Society Management System</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>





            </div >
            <hr />


            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation16;